// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgMinusIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path fillRule="evenodd" d="M10.611 11h10a1.389 1.389 0 1 1 0 2.778H3.39a1.389 1.389 0 1 1 0-2.778z" />
  </g>
);
export default SvgMinusIcon;
SvgMinusIcon.displayName = 'SvgMinusIcon';
